import "./BattleVideoGenerator.scss";
import Control from "../1. Core/Control";
import CheckBox from "../1. Core/Controls/CheckBox/CheckBox";
import NP, {EventArgs, IHash} from "../1. Core/NP";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import Label from "../1. Core/Controls/Label/Label";
import {ServerAPI} from "../1. Core/ServerAPI";
import {FunnyItem, HighlightRow, IBattle} from "../10. Battle/types";

import {secondsToTime} from "../10. Battle/Util";
import Select from "../1. Core/Controls/Select/Select";
import {HLBattle, MAIN_SERVER_URL, Segment, VideoInfo} from "./types";
import Button from "../1. Core/Controls/Button/Button";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import EditMMAEventDialog from "../9. DataInput/EditMMAEventDialog";
import WorldTimeEdit from "../1. Core/Controls/TimeEdit/WorldTimeEdit";
import EditMMAFunnyDialog from "../9. DataInput/EditMMAFunnyDialog";
import Delegate from "../1. Core/Delegate";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import TextField from "../1. Core/Controls/TextField/TextField";
import {createFunnyRow, getPointTimeFromWT, showSegmentMenu} from "./func";

let moment = require('moment');

export default class BattleVideoGenerator extends Control {

	private _Battle: IBattle;


	private _dataTable: DataTable;
	private _allActionList: HighlightRow[];
	private _allFunnyList: FunnyItem[];
	private _tableNode: HTMLElement;

	private _point1: CheckBox;
	private _point2: CheckBox;
	private _point3: CheckBox;
	private _point35: CheckBox;
	private _point4: CheckBox;
	private _sumLabel: Label;

	private _GridHeight: number;

	private _addFirstPreview: CheckBox;
	private _addRoundPreview: CheckBox;
	public _videoStartWorldTimeInput: WorldTimeEdit;


	private _videoType: Select;

	private _lockUpdateSegmentsView: boolean;
	private _videoTypeLabel: Label;
	private _videoPreviewType: Select;


	private _rightNode: HTMLElement;
	private _videoFormatLabel: Label;

	private _updateTimeId: any;
	private _ShowVideo: boolean

	private _videoNode: HTMLVideoElement;

	private _transitionType: Select;
	private _leftNode: HTMLElement;

	private _videoProgressBar: HTMLElement;
	private EvVideoSettingsChanged: Delegate;
	private _hlbattleItems: HLBattle[];
	updateHLButton: Button;

	_RoundPreview: boolean
	private _videoStartLabel: Label;
	private _SuperWithoutPoint: boolean;
	private _addWallpaperToEnd: CheckBox;
	private _showSettingButton: IconToggleButton;

	constructor(settings?: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._SuperWithoutPoint = true;
		this._RoundPreview = true;
		this.EvVideoSettingsChanged = new Delegate();
		this._ShowVideo = true;
		this._Battle = null;
		this._GridHeight = 500;
		super._initFields(settings);
	}

	async _render()
	{
		this.np_render();
		this.addClass('battle-video-generator')

		this._leftNode = NP.createNode(this._root)
		this._rightNode = NP.createNode(this._root, 'right-video-setting')

		this.createVideoTypeSettings();

		this._tableNode = NP.createNode(this._leftNode, 'video-table-node');

		this._dataTable = new DataTable({
			ShowSettingsButton: false,
			CustomSettingsButton: [{
				FontImage: NP.FontImages.arrow_right,
				ToolTip: NP.RM.getString('ShowOnVideo'),
				EvClick: (btn: Button) =>
				{
					this.viewEvent(btn.getData())
				}
			}],
			ParentNode: this._tableNode,
			EnableSort: false,
			Height: this._GridHeight,
			Width: 900,
			HeaderPaddingRight: '107px',
			MultiSelect: true,
			CustomSettingsButtonCreated: (ctrl: IconToggleButton, index: number) =>
			{
				let row = ctrl.getData();
				if (row?.MMAEvent?.SegmentFileName)
				{
					ctrl.getRoot().style.color = "#00c77e"
				}
			},
			EvSelectionChanged: () =>
			{
				this.refreshSegmentView()
			},
			IsRowSelected: (row: any) => true,
			Columns: [{
				Content: 'R',
				PropertyContent: 'Round',
				Width: '30px'
			}, {
				Content: 'Action',
				PropertyContent: 'Action',
				Width: '77px'
			}, {
				Content: 'Z',
				PropertyContent: 'Zone',
				Width: '30px'
			}, {
				Content: 'Answer',
				PropertyContent: 'Answer',
				Width: '90px'
			}, {
				Content: 'Time',
				PropertyContent: 'Time',
				Width: '90px'
			}, {
				Content: 'World Time',
				PropertyContent: 'WorldTimeStr',
				Width: '90px'
			}, {
				Content: 'Desc',
				PropertyContent: 'HLDesc',
				Width: '190px'
			}, {
				Content: 'Position',
				PropertyContent: 'Position',
				Width: '100px'
			}, {
				Content: '-Prev+Next',
				PropertyContent: 'PrevNext',
				Width: '100px'
			}, {
				Content: 'Point',
				PropertyContent: 'Point',
				Width: '80px'
			}],
			EvItemContextMenu: (s: object, e: {
				Item: { MMAEvent: HighlightRow, FunnyEvent: FunnyItem },
				Node: HTMLElement
			}) =>
			{
				let ev = e.Item.MMAEvent || e.Item.FunnyEvent;
				if (ev)
					showSegmentMenu(ev, this._videoNode, e.Node, this._dataTable, this._videoStartWorldTimeInput.getValue(),
						 this.createRow.bind(this),
						 this.calcVideoPointPosition.bind(this))
			},
			EvItemClick: (s: any, e: { Item: any }) => this.editEvent(e.Item),
		});

		this.renderFilters();

		//-------------------------------------------------------------

		this.createVideoSettings()


		if (this._Battle.VideoUrl && this._ShowVideo)
		{
			this._videoNode = NP.createNode(this._rightNode, 'battle-video-node', 'video')
			this._videoNode.setAttribute('controls', 'true')
			if (this._Battle.VideoUrl.startsWith("http"))
				this._videoNode.src = this._Battle.VideoUrl;
			else
				this._videoNode.src = `${MAIN_SERVER_URL}/video/battle_${this._Battle.Id}.mp4`

			this._videoProgressBar = NP.createNode(this._rightNode, 'video-progress-bar');

			this._videoFormatLabel = new Label({
				ParentNode: this._rightNode,
				RK: 'DetectingVideoFormat'
			})
			this._videoFormatLabel.getRoot().style.display = 'block'

			ServerAPI.get(`/video/getVideInfo/${this._Battle.Id}`, false).then((info: VideoInfo) =>
			{
				if (this._videoFormatLabel)
				{
					if (info)
						this._videoFormatLabel.setContent(`kbs: ${info.kbs}, fps: ${info.fps}, tbr: ${info.tbr}, audioHz: ${info.audioHz}`);
					else
						this._videoFormatLabel.setContent('')
				}
			})

			new Button({
				Class: 'app-button--raised green-btn',
				ParentNode: this._rightNode,
				Content: 'Reload Video',
				EvClick: async () =>
				{
					let ct = this._videoNode.currentTime
					this._videoNode.src = null;
					let fileName = await ServerAPI.post<string>(`/video/createCopyVideoStream/${this._Battle.Id}`, null)

					if (fileName)
					{
						this._videoNode.src = `${MAIN_SERVER_URL}/video/${fileName}?c=${new Date().getTime()}`
						this._videoNode.currentTime = ct;
					}

					this.refreshDataTable()
				}
			})

			let orBtn = new Button({
				Class: 'app-button--raised green-btn',
				ParentNode: this._rightNode,
				Content: 'Original Video',
				EvClick: async () =>
				{
					this._videoNode.src = `${MAIN_SERVER_URL}/video/battle_${this._Battle.Id}.mp4`
				}
			})

			orBtn.getRoot().style.marginLeft = '12px'
		}


		this.refreshDataTable();

		this.updatePreviewList();
	}

	createVideoSettings()
	{
		let firstVideoSettingsRow = NP.createNode(this._rightNode, 'first-row-video-settings')

		this._videoStartLabel = new Label({
			ParentNode: firstVideoSettingsRow,
			RK: 'VideoWorldStartTime'
		})


		this._videoStartWorldTimeInput = new WorldTimeEdit({
			ParentNode: firstVideoSettingsRow,
			Width: 200,
			FontImage: NP.FontImages.url,
			Value: this._Battle.VideoStartTime,
			EvChanged: () =>
			{
				this.refreshVideoProgressBar();
			}
		});


		this._showSettingButton = new IconToggleButton({
			ParentNode: firstVideoSettingsRow,
			FontImage: NP.FontImages.tune,
			ToolTip: NP.RM.getString('Settings'),
			EvClick: () =>
			{
				if (moreSettingsVideoNode.classList.contains('hide'))
				{
					NP.show(moreSettingsVideoNode)
					this._transitionType.show();
				}
				else
				{
					NP.hide(moreSettingsVideoNode)
					this._transitionType.hide();
				}
			}
		})


		let secondVideoSetting = NP.createNode(this._rightNode, 'right-node-settings')

		this._videoPreviewType = new Select({
			ParentNode: secondVideoSetting,
			Width: 200,
			EvItemSelected: () => this.EvVideoSettingsChanged.fire(this)
		})

		let moreSettingsVideoNode = NP.createNode(secondVideoSetting);

		this._addFirstPreview = new CheckBox({
			ParentNode: moreSettingsVideoNode,
			Content: 'Add first preview',
			Checked: true,
			EvCheckedChanged: () => this.EvVideoSettingsChanged.fire(this)
		});

		this._addRoundPreview = new CheckBox({
			ParentNode: moreSettingsVideoNode,
			Content: 'Add round previews',
			Checked: this._RoundPreview,
			EvCheckedChanged: () => this.EvVideoSettingsChanged.fire(this)
		});

		this._addWallpaperToEnd = new CheckBox({
			ParentNode: moreSettingsVideoNode,
			Content: 'Add Wallpaper to end',
			Checked: false,
			EvCheckedChanged: () => this.EvVideoSettingsChanged.fire(this)
		});

		NP.hideNode(moreSettingsVideoNode)


		let node = NP.createNode(this._rightNode);
		node.style.display = 'flex';
		node.style.alignItems = 'flex-start'

		this._sumLabel = new Label({
			ParentNode: node,
			Class: 'video-sum-text'
		})

		this._transitionType = new Select({
			ParentNode: node,
			FloatingLabel: 'Transitions',
			Width: 200,
			Items: [
				{RK: 'None', Value: ''},
				{Content: 'Opacity Fade', Value: 'opacity-fade'},
				//{Content: 'Black Fade', Value: 'black-fade'}
			]
		})

		this._transitionType.getRoot().style.marginLeft = 'auto'

		this._transitionType.hide();
	}

	refreshVideoProgressBar()
	{
		if (this._videoProgressBar)
		{
			this._videoProgressBar.innerHTML = '';
			let rows = this._dataTable.getSelection();
			let actionList = this._allActionList.filter(row => rows.find(r => row.EventOrder == (r as unknown as HighlightRow).EventOrder));
			let funnyList = this._allFunnyList.filter(row => rows.find(r => row.Id == (r as unknown as FunnyItem).Id));

			//let width = this._videoProgressBar.offsetWidth;
			let duration = this._videoNode.duration;

			actionList.forEach(a =>
			{

				let hint = a.Action + " " + (a.Zone || '');
				if (a.HLDesc)
					hint += ` (${a.HLDesc})`

				this.createVideoProgressNode(duration, hint, a.ActionAthleteId == this._Battle.Red, a)
			})

			funnyList.forEach(a =>
			{
				this.createVideoProgressNode(duration, a.Action, a.AthleteId ? a.AthleteId == this._Battle.Red : null, a)
			})
		}
	}

	createVideoProgressNode(fullDuration: number,
									hint: string,
									isRed: boolean,
									point: HighlightRow | FunnyItem)
	{

		let node = NP.createNode(this._videoProgressBar, 'progress-point');
		if (isRed != null)
			node.style.backgroundColor = isRed ? NP.RED_COLOR : NP.BLUE_COLOR;
		else
			node.style.backgroundColor = 'green'

		node.point = point;
		node.setAttribute('title', hint)
		this.calcVideoPointPosition(node, point, fullDuration)
		this._addEvent(node, 'click', this.onPointClick)
		this._addEvent(node, 'contextmenu', this.onPointContextMenu)
	}

	calcVideoPointPosition(node: HTMLElement, point: HighlightRow | FunnyItem, fullDuration)
	{
		let pointTime = getPointTimeFromWT((point as HighlightRow).ActionTS || (point as FunnyItem).HighlightDate,
			 this._videoStartWorldTimeInput.getValue());

		let segmentDuration = point.TimeInfo.NextSeconds + point.TimeInfo.PrevSeconds;
		node.style.width = (100 * segmentDuration / fullDuration) + '%'
		node.style.left = (100 * pointTime / fullDuration - 100 * point.TimeInfo.PrevSeconds / fullDuration) + '%';
		node.setAttribute('time', pointTime + '')
	}

	onPointClick(sender: object, args: EventArgs)
	{
		let node = args.Event.target as HTMLElement;
		this._videoNode.currentTime = parseInt(node.getAttribute('time'));
	}

	onPointContextMenu(sender: object, args: EventArgs)
	{
		let node = args.Event.target as HTMLElement;

		let battleEvent = (node as any).point as HighlightRow | FunnyItem;
		showSegmentMenu(battleEvent, this._videoNode, node, this._dataTable, this._videoStartWorldTimeInput.getValue(),
			 this.createRow.bind(this),
			 this.calcVideoPointPosition.bind(this))
	}

	async createVideoTypeSettings()
	{
		let node = NP.createNode(this._leftNode, 'left-video-filter') as HTMLElement;
		this._videoTypeLabel = new Label({ParentNode: node, RK: 'HLType'})
		this._videoType = new Select({
			ParentNode: node,
			SelectedIndex: 0,
			Width: 200,
			Items: [{RK: 'None', Value: null}, {Content: 'Full', Value: 'full'}, {
				Content: 'Optimal',
				Value: 'optimal'
			}, {Content: 'Short', Value: 'short'}],
			EvItemSelected: () => this.updateTableByVideoType()
		})

		new Button({
			ParentNode: node,
			Class: 'app-button--raised',
			Content: 'Save',
			EvClick: () =>
			{
				(new Dialog({
					ShowHeader: true,
					Caption: 'Enter selection name',
					Content: new TextField({}),
					EvOkButtonClick: async (dlg: Dialog) =>
					{
						this.saveToNewHL(dlg.getContent().getValue())
					}
				})).show()
			}
		})


		this.updateHLButton = new Button({
			ParentNode: node,
			Content: 'Update',
			Class: 'app-button--raised',
			EvClick: () => this.updateHLBattle()
		})

		this.updateHLButton.getRoot().style.marginLeft = '12px';
		this.updateHLButton.setIsVisible(false)

		this._hlbattleItems = await ServerAPI.get<HLBattle[]>(`/highlight/getHLBattleItems/${this._Battle.Id}`)

		this._hlbattleItems.forEach(item =>
		{
			this._videoType.addItem({
				Content: item.Name,
				Value: item.Id
			})
		})
	}

	async updateHLBattle()
	{
		let rows = this._dataTable.getSelection();
		let item = this._hlbattleItems.find(i => i.Id == this._videoType.getValue());
		if (item)
		{
			item.MMAEventList = this._allActionList.filter(row => rows.find(r => row.EventOrder == (r as unknown as HighlightRow).EventOrder)).map(item => item.EventOrder);
			item.FunnyEventList = this._allFunnyList.filter(row => rows.find(r => row.Id == (r as unknown as FunnyItem).Id)).map(item => item.Id);
			await ServerAPI.post(`/highlight/updateHLBattle`, item)
			return item.Id
		}
		else
			return null;
	}

	async saveToNewHL(name: string)
	{
		let rows = this._dataTable.getSelection();

		let newItem = {
			Name: name,
			BattleId: this._Battle.Id,
			MMAEventList: this._allActionList.filter(row => rows.find(r => row.EventOrder == (r as unknown as HighlightRow).EventOrder)).map(item => item.EventOrder),
			FunnyEventList: this._allFunnyList.filter(row => rows.find(r => row.Id == (r as unknown as FunnyItem).Id)).map(item => item.Id)
		} as HLBattle

		newItem.Id = await ServerAPI.post(`/highlight/addHLBattle`, newItem)
		this._hlbattleItems.push(newItem)

		this._videoType.addItem({
			Content: newItem.Name,
			Value: newItem.Id
		})

		this._videoType.setValue(newItem.Id, false);
		this.updateHLButton.setIsVisible(true)

		return newItem.Id
	}


	renderFilters()
	{
		let filtersNode = NP.createNode(this._leftNode, 'left-video-filter') as HTMLElement;


		new Label({ParentNode: filtersNode, RK: 'Points'})

		this._point1 = new CheckBox({
			ParentNode: filtersNode,
			Content: '1',
			Data: 'Bad',
			Checked: false,
			EvCheckedChanged: () => this.onPointChanged()
		});
		this._point2 = new CheckBox({
			ParentNode: filtersNode,
			Content: '2',
			Data: 'Poor',
			Checked: false,
			EvCheckedChanged: () => this.onPointChanged()
		});
		this._point3 = new CheckBox({
			ParentNode: filtersNode,
			Content: '3',
			Data: 'Good',
			Checked: false,
			EvCheckedChanged: () => this.onPointChanged()
		});
		this._point35 = new CheckBox({
			ParentNode: filtersNode,
			Content: '3.5',
			Data: '3.5',
			Checked: true,
			EvCheckedChanged: () => this.onPointChanged()
		});
		this._point4 = new CheckBox({
			ParentNode: filtersNode,
			Content: '4',
			Data: 'Great',
			Checked: true,
			EvCheckedChanged: () => this.onPointChanged()
		});

	}

	getTransitionType()
	{
		return this._transitionType.getValue();
	}

	isRelativeTimeStart()
	{
		return false
	}

	viewEvent(dtRow: any)
	{
		this._videoNode.currentTime = getPointTimeFromWT(dtRow.MMAEvent?.ActionTS || dtRow.FunnyEvent.HighlightDate,
			 this._videoStartWorldTimeInput.getValue());
	}

	getTimeHL(str): number
	{
		return moment(str, 'YYYY-MM-DD HH:mm:ss.SSS').toDate().getTime()
	}

	editEvent(row: IHash<string>)
	{
		if (row.MMAEvent)
			(new EditMMAEventDialog({
				Event: row.MMAEvent,
				Battle: this._Battle,
				EvSaved: () =>
				{
					let newRow = this.createRow(row.MMAEvent as any)

					for (let key in row)
						row[key] = newRow[key]

					this._dataTable.updateRow(row)

					this.refreshSegmentView();
				}
			})).show()

		else if (row.FunnyEvent)
		{
			(new EditMMAFunnyDialog({
				Event: row.FunnyEvent,
				EvSaved: () =>
				{
					let newRow = createFunnyRow(row.FunnyEvent as any)

					for (let key in row)
						row[key] = newRow[key]

					this._dataTable.updateRow(row)

					this.refreshSegmentView();
				}
			})).show()
		}
	}


	async updatePreviewList()
	{
		let items = await ServerAPI.get(`/video/getPreviewVideos`, false) as string[];

		if (this._videoPreviewType)
		{
			let mIndex = 0;
			this._videoPreviewType.setItems(items.map((item, idx) =>
			{
				let arr = item.split("_");
				if (arr[0] == 'MatchTVNew')
					mIndex = idx;
				return {Content: arr[0] + " (" + arr[1] + "fps)", Value: item}
			}))

			this._videoPreviewType.setSelectedIndex(mIndex);
		}
	}

	setHeight(value?: number, fireEvents?: boolean)
	{
		super.setHeight(value, fireEvents);
		this._dataTable?.setHeight(value - 150);
	}

	async onPointChanged()
	{
		await this.refreshDataTable(false)


		this.refreshSegmentView();
	}


	async updateTableByVideoType()
	{
		this.updateHLButton.setIsVisible(false)

		let videoType = this._videoType.getValue();

		if (!videoType)
			return;

		this._lockUpdateSegmentsView = true

		try
		{

			switch (videoType)
			{
				case 'optimal':
					await this.doOptimal()
					break;
				case 'short':
					await this.doShort()
					break;
				case 'full':
					await this.doFull();
					break;
				default:
					this.applyHLBattle([videoType])
					break;
			}
		} finally
		{
			this._lockUpdateSegmentsView = null;
		}
		this.refreshSegmentView();
	}

	setVideoType(value: string)
	{
		this._videoType.setValue(value, true)
	}

	applyHLBattle(ids: number[])
	{
		let hlb = this._hlbattleItems.find(item => ids.indexOf(item.Id) > -1)

		if (hlb)
		{
			let rows = this._dataTable.getRows() as any[];

			rows.forEach(row =>
			{
				if (row.FunnyEvent && hlb.FunnyEventList.indexOf(row.FunnyEvent.Id) > -1)
					this._dataTable.setRowSelected(row, true)
				else if (row.MMAEvent && hlb.MMAEventList.indexOf(row.MMAEvent.EventOrder) > -1)
					this._dataTable.setRowSelected(row, true)
				else
					this._dataTable.setRowSelected(row, false)
			})

			this._videoType.setValue(hlb.Id, false)
			this.updateHLButton.setIsVisible(true)
		}
	}

	async doShort()
	{
		// +все с оценкой 4
		// успешные Takedowns Transition
		// успешный Sub
		// развернутые удары кроме Calf kick и Oblique kick с пометкой Hit или Block
		// последнее действие в бою

		this._point1.setChecked(false, false);
		this._point2.setChecked(false, false);
		this._point3.setChecked(false, false);
		this._point35.setChecked(true, false);
		this._point4.setChecked(true, false);


		await this.refreshDataTable(false)

		let last = this._allActionList[this._allActionList.length - 1];

		let rows = this._dataTable.getRows() as any[];
		rows.filter(r => r.FunnyEvent?.Action == 'Walkout' || r.FunnyEvent?.Action == 'ShowRespect' || r.FunnyEvent?.Action == 'Staredown').forEach(row =>
		{
			this._dataTable.setRowSelected(row, false)
		})

		await this.updateTableByPropName((hl: HighlightRow) =>
		{
			if (hl.IsReversal)
				return false;

			if (hl.ManualPoint == 4)
				return true;

			if ((hl.Action == 'Transition' || hl.Action == 'Takedown'))
			{
				return hl.Answer == 'Hit';
			}

			if (last.EventOrder == hl.EventOrder)
			{
				if (this._SuperWithoutPoint || hl.ManualPoint == 3.5 || hl.ManualPoint == 4)
					return true;
			}

			if (hl.Action == 'Submission' && hl.Answer == 'Hit')
				return true;

			if (hl.Action == 'Kick' && hl.Zone == 'P1' && hl.Answer == 'Hit')
				return true;

			if (hl.HLDesc)
			{
				if (hl.HLDesc == 'Calf Kick' || hl.HLDesc == 'Oblique Kick')
					return false;
				else if (this._SuperWithoutPoint || hl.ManualPoint == 3.5 || hl.ManualPoint == 4)
					return hl.Answer == 'Hit' || hl.Answer == 'Block';
			}
			return false;
		})
	}

	async doOptimal()
	{
		this._point1.setChecked(false, false);
		this._point2.setChecked(false, false);
		this._point3.setChecked(false, false);
		this._point35.setChecked(true, false);
		this._point4.setChecked(true, false);


		await this.refreshDataTable(false)


		let rows = this._dataTable.getRows() as any[];

		rows.filter(r => r.FunnyEvent?.Action == 'ShowRespect' || r.FunnyEvent?.Action == 'Staredown').forEach(row =>
		{
			this._dataTable.setRowSelected(row, false)
		})

		await this.updateTableByPropName((hl: HighlightRow) => this.isOptimalRow(hl))
	}

	isOptimalRow(hl: HighlightRow)
	{
		if (hl.ManualPoint == 3.5 || hl.ManualPoint == 4)
			return true;

		if (this._allActionList[this._allActionList.length - 1].EventOrder == hl.EventOrder)
			return true;


		if (hl.Action == 'Control' && (hl.HLDesc == 'Leg' || hl.HLDesc == 'Other'))
			return false;

		if (hl.Action == 'Elbow' && hl.Zone == 'P1' && (hl.GroundStart || hl.GrappleStart))
			return false;

		if (hl.IsReversal && hl.HLDesc)
			return true;

		if (hl.Action == 'Submission')
			return true;

		if ((hl.Action == 'Transition' || hl.Action == 'Takedown') && hl.Answer != 'Hit')
		{
			return false;
		}
		else if (hl.Action == 'Control' && hl.Answer == 'Hit')
		{
			return false;
		}
		else if (hl.Answer == 'Hit' && hl.Zone == 'P1' && hl.Action == 'Punch')
		{
			return false;
		}

		if (hl.HLDesc)
		{
			if (hl.HLDesc == 'Calf Kick' || hl.HLDesc == 'Oblique Kick')
				return false;
			else
				return true;
		}
		else
			return null;
	}

	async doFull()
	{
		this._point1.setChecked(false, false);
		this._point2.setChecked(false, false);
		this._point3.setChecked(false, false);
		this._point35.setChecked(true, false);
		this._point4.setChecked(true, false);


		await this.refreshDataTable(false)

		await this.updateTableByPropName((hl: HighlightRow) =>
		{
			if (hl.Answer == 'Hit' && hl.Zone == 'P1')
				return true;

			if (hl.Action == 'Transition' || hl.Action == 'Takedown')
				return true;

			return this.isOptimalRow(hl);
		})
	}


	async updateTableByPropName(itemCallback: Function)
	{
		let rows = this._dataTable.getRows() as any[];


		for (let row of rows)
		{
			if (row.HLDesc == 'RoundEnd')
			{
				this._dataTable.setRowSelected(row, false)
				continue
			}
			let hl = this._allActionList.find(r => row.EventOrder == r.EventOrder);

			if (!hl)
				continue;

			let include = itemCallback(hl);
			if (include == null)
				continue;

			this._dataTable.setRowSelected(row, include)
		}

		if (!this._lockUpdateSegmentsView)
			await this.refreshSegmentView();
	}

	async refreshDataTable(refreshSegments = true)
	{
		let points = [this._point1, this._point2, this._point3, this._point35, this._point4]
			 .filter(cb => cb.getChecked())
			 .map(cb => cb.getData())

		let rowsData = await ServerAPI.post(`/video/getHighlights/${this._Battle.Id}`, {
			points: points,
			include3Punch: this._videoType.getValue() != 'short',
			addLastEvent: true
		}) as HighlightRow[];

		let funnyData = await ServerAPI.get(`/highlight/getHighlightFunny/${this._Battle.Id}`) as FunnyItem[];


		this._allActionList = rowsData;
		this._allFunnyList = funnyData;

		this.renderDataTable();


		if (refreshSegments)
			await this.refreshSegmentView();
	}

	renderDataTable()
	{
		let rowsData = this._allActionList;
		let funnyData = this._allFunnyList;

		let data = [];

		for (let f of funnyData)
			data.push(createFunnyRow(f))

		for (let f of rowsData)
			data.push(this.createRow(f))


		data.sort((a, b) => a.WorldTime.getTime() - b.WorldTime.getTime());

		this._dataTable.setRows(data);

		let gongRow = this._dataTable.getRows().find((row: any) => row.FunnyEvent?.Action == 'Gong');
		if (gongRow)
			this._dataTable.setRowSelected(gongRow, false)
	}


	createRow(f: HighlightRow)
	{
		let m = moment(f.ActionTS, 'YYYY-MM-DD HH:mm:ss.S')

		let action = f.Action;
		if (f.Favorite == 1)
			action = action.toUpperCase();

		return {
			...f,
			Action: action,
			Position: f.GroundStart ? 'Ground' : (f.GrappleStart ? 'Grapple' : ''),
			Data: f,
			Point: f.ManualPoint || f.AutoPoint,
			WorldTime: m.toDate(),
			WorldTimeStr: m.format('HH:mm:ss'),
			MMAEvent: f,
			PrevNext: `-${f.TimeInfo.PrevSeconds} + ${f.TimeInfo.NextSeconds}`,
			CssClass: f.ActionAthleteId == this._Battle.Red ? 'red-row' : 'blue-row'
		}
	}

	async refreshSegmentView()
	{
		if (this._updateTimeId)
			clearTimeout(this._updateTimeId);

		this._updateTimeId = setTimeout(async () =>
		{
			let rows = this._dataTable.getSelection();

			let actionList = this._allActionList.filter(row => rows.find(r => row.EventOrder == (r as unknown as HighlightRow).EventOrder));
			let funnyList = this._allFunnyList.filter(row => rows.find(r => row.Id == (r as unknown as FunnyItem).Id));


			let response = await ServerAPI.post(`/video/getSegments/${this._Battle.Id}`, {
				videoStartTime: this._videoStartWorldTimeInput.getValue(),
				isRelativeTimeStart: this.isRelativeTimeStart(),
				funnyList: funnyList,
				rows: actionList
			}, false) as {
				List: Segment[],
				ErrorText: string
			};

			if (response.ErrorText)
			{
				this._sumLabel.setContent(response.ErrorText)
				return;
			}

			let text = '';
			let rnd = 1;
			let cnt = 0;
			let sumRoundTime = 0
			let allRoundsTime = 0;

			for (let seg of response.List)
			{
				if (seg.Row)
				{
					if (seg.Row.Round != rnd)
					{
						text += `Раунд ${rnd}: Число отрезков = ${cnt}, на сумму ${secondsToTime(sumRoundTime)} <br/> `

						rnd = seg.Row.Round;
						cnt = 0;
						sumRoundTime = 0;
					}

					sumRoundTime += seg.End - seg.Start;
					allRoundsTime += seg.End - seg.Start;
					cnt++
				}
			}

			text += `Раунд ${rnd}: Число отрезков = ${cnt}, на сумму ${secondsToTime(sumRoundTime)} <br/> `

			for (let seg of response.List)
			{
				if (!seg.Row)
				{
					allRoundsTime += seg.End - seg.Start;
				}
			}

			text += `Итого (с выходами и т.д.): ${secondsToTime(allRoundsTime)}`


			this._sumLabel.setContent(text)

			this.refreshVideoProgressBar()

		}, 100);
		// this._segmentList.setItems([{IsHeader: true, Content: 'Отрезки'}, ...segments.map(s => ({
		// 	Content: `${secondsToTime(s.Start)} - ${secondsToTime(s.End)}`
		// }))]);
	}

	// getFileLocation()
	// {
	// 	return this._videoLocation.getValue();
	// }
	//
	// getRoundStartTime()
	// {
	// 	return this._startRound1Time.getValue()
	// }

	getFunnyList()
	{
		let rows = this._dataTable.getSelection();
		// @ts-ignore
		let res = this._allFunnyList.filter(row => rows.find(r => row.Id == r.Id));
		return res.length ? res : null;
	}

	getSelectedActionList()
	{
		let rows = this._dataTable.getSelection();
		// @ts-ignore
		let res = this._allActionList.filter(row => rows.find(r => row.EventOrder == r.EventOrder));
		return res.length ? res : null;
	}

	getBattle()
	{
		return this._Battle;
	}

	getRoundPreviewVideo()
	{
		return this._addRoundPreview.getChecked();
	}

	getFirstPreviewVideo()
	{
		return this._addFirstPreview.getChecked();
	}

	setFirstPreviewVideo(value: boolean)
	{
		this._addFirstPreview.setChecked(value, false)
	}

	getVideoWorldStartWorldTime()
	{
		return this._videoStartWorldTimeInput.getValue();
	}


	getVideoType()
	{
		return this._videoType.getValue()
	}

	getPreviewType()
	{
		return this._videoPreviewType.getValue()
	}

	setPreviewType(value: number)
	{
		this._videoPreviewType.setValue(value, false)
	}

	getAddWallpaperToEnd()
	{
		return this._addWallpaperToEnd.getChecked();
	}

	setAddWallpaperToEnd(value: boolean)
	{
		this._addWallpaperToEnd.setChecked(value, false)
	}
}

